import React from 'react';
// import { HashLoader } from 'react-spinners';

const Loader = ({ loading, size, color }) => {
    return (

        // <div>
        //     {loading && (
        //         <div className="fixed inset-0 z-[100] bg-black opacity-80"></div>
        //     )}
        //     <div className={`absolute inset-0 flex justify-center whitespace-nowrap items-center ${loading ? 'z-50' : 'z-[-10]'}`}>
        //         <HashLoader
        //             color={color}
        //             loading={loading}
        //             size={50}
        //             aria-label="Loading Spinner"
        //         />
        //     </div>
        // </div>
        <>
            {loading ? (
                <div className="fixed inset-0 flex items-center justify-center bg-gray-900/70 backdrop-blur-sm z-[9999]">
                    <div className="relative flex items-end h-[120px] gap-3">
                        {["P", "K", "R", "D"].map((char, index) => (
                            <div
                                key={index}
                                className="text-[#2EFF6D] font-mono text-[48px] font-extrabold tracking-tighter"
                                style={{
                                    animation: `wave 2.4s cubic-bezier(0.4, 0, 0.2, 1) infinite ${index * 0.15}s`,
                                    textShadow: `
              0 0 8px rgba(46, 255, 109, 0.7),
              2px 2px 4px rgba(0, 80, 20, 0.4),
              4px 4px 8px rgba(0, 60, 15, 0.3),
              6px 6px 12px rgba(0, 40, 10, 0.2)`,
                                    transformStyle: 'preserve-3d',
                                    willChange: 'transform, opacity',
                                }}
                            >
                                {char}
                            </div>
                        ))}
                    </div>

                    <style jsx>
                        {`
      @keyframes wave {
        0%, 100% {
          transform: 
            translateY(0) 
            rotateX(0deg) 
            scale(1);
          opacity: 1;
          filter: brightness(1);
        }
        20% {
          transform: 
            translateY(-35px) 
            rotateX(25deg) 
            scale(1.25);
          opacity: 0.95;
          filter: brightness(1.3);
        }
        40% {
          transform: 
            translateY(5px) 
            rotateX(-10deg) 
            scale(0.98);
          filter: brightness(1.1);
        }
        60% {
          transform: 
            translateY(-15px) 
            rotateX(15deg) 
            scale(1.15);
          filter: brightness(1.2);
        }
        80% {
          transform: 
            translateY(0px) 
            rotateX(-5deg) 
            scale(1.05);
          filter: brightness(1.1);
        }
      }
    `}
                    </style>
                </div>
            ) : null}
        </>
    );
};

Loader.defaultProps = {
    loading: true,
    size: 50,
    color: '#25c20e',
};

export default React.memo(Loader);

